'use strict';

var React = require('react'),
    _ = require('underscore'),
    Link = require('./Link'),
    Icon = require('./Icon'),
    ShareTypes = require('../constants/ShareTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getShareServiceTitle = require('../utils/getShareServiceTitle'),
    { PropTypes } = React;

var ShareLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    service: PropTypes.oneOf(_.values(ShareTypes)).isRequired,
    propagateClick: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  },

  render() {
    return (
      <Link onClick={this.props.onClick}
            color='dark'
            propagateClick={this.props.propagateClick}
            context={this.props.context}
            bold={this.props.bold}
            underline={this.props.underline}>
        <Icon name={this.props.service.toLowerCase()}
              context='Link' />
        {getShareServiceTitle(this.props.service)}
      </Link>
    );
  }
});

module.exports = ShareLink;



/** WEBPACK FOOTER **
 ** ./atoms/ShareLink.jsx
 **/